import React, { useState } from 'react';

import { useRESTDataCache } from '@atresmedia/elections_modules_library/dist/dataProvider';
import ElTabs from '@atresmedia/elections_modules_library/dist/components/elTabs';

import './style.scss';
import Module from './module';

import ButtonGenerator from './buttonGenerator';
import { PlacesSelector } from './placesSelector';
import ModuleGeneratorHeader from './header';
import { PROPERTIES_JSON } from '../../core/constants';

const ModuleGeneratorContent = ({ host, setHost, generatorInfo, targets }) => {
  // [host || 'antena3'].generator
  const { generator } = generatorInfo[host] || generatorInfo['antena3'];
  const { config, individualGenerator, multipleGenerator } = generator;
  const { doble, type, year, electionNumber } = config;

  const [moduleParameters, setModuleParameters] = useState({
    locations: targets,
  });
  const [navegable, setNavegable] = useState(0);
  const [multipleModule, setMultipleModule] = useState(doble);

  const setDouble = (isDouble) => {
    setMultipleModule(isDouble);
    if (isDouble) {
      setModuleParameters({
        location: targets,
      });
    } else {
      setModuleParameters({
        locations: [],
      });
    }
  };

  const setLocation = (locations) => {
    setModuleParameters({
      locations,
    });
  };

  const reset = () => {
    setModuleParameters({
      locations: targets,
    });
  };

  const { locations } = moduleParameters;
  const ineId = locations && locations[0] && locations[0].ineId;

  const selectedModules = multipleModule
    ? multipleGenerator
    : individualGenerator;
  const selectedTabs = (selectedModules[ineId] || selectedModules.commons).data
    .tabs;
  const show =
    type && locations && locations.length && multipleModule
      ? locations.length === targets.length
      : locations && locations.length;
  return (
    <div className="GenerateIframePage">
      <ModuleGeneratorHeader
        doble={doble}
        host={host}
        navegable={navegable}
        multipleModule={multipleModule}
        reset={reset}
        setHost={setHost}
        setDouble={setDouble}
        setNavegable={setNavegable}
      ></ModuleGeneratorHeader>

      <PlacesSelector
        regions={targets.reduce((t, c) => `${t}${c.name},`, '')}
        targets={multipleModule ? targets : [targets[0]]}
        onChangeSelection={(items) => {
          console.log(items);
          setLocation(items.length ? items : targets);
        }}
      ></PlacesSelector>

      {show && (
        <div>
          <h3>
            {locations.reduce((total, current, index, arr) => {
              if (index === arr.length - 1) {
                return `${total.substr(0, total.length - 1)} y ${current.name}`;
              }
              return `${total}${current.name},`;
            }, ` Módulos `)}
          </h3>
          <ElTabs titles={selectedTabs.map((tab) => tab.title)}>
            {selectedTabs.map((tab) => {
              if (tab.component === 'BUTTONS') {
                return (
                  <ButtonGenerator
                    key={tab.component}
                    electionType={type}
                    parentPlace={locations[0]}
                    year={year}
                    electionNumber={electionNumber}
                  />
                );
              }
              return (
                <Module
                  key={tab.component}
                  navegable={navegable}
                  year={year}
                  type={tab.component}
                  electionType={type}
                  electionName={type}
                  locations={locations}
                  site={host}
                />
              );
            })}
          </ElTabs>
        </div>
      )}
    </div>
  );
};
const ModuleGenerator = ({ host, setHost }) => {
  const params = useRESTDataCache(PROPERTIES_JSON(), 'GLOBAL_CONFIG', null);
  return params ? (
    <ModuleGeneratorContent
      host={host}
      setHost={setHost}
      generatorInfo={params.sites}
      targets={params.targets}
    ></ModuleGeneratorContent>
  ) : (
    <div>Loading...</div>
  );
};
export default ModuleGenerator;
